import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/_main.scss";
import { App } from "./App";
import { ErrorBoundary } from "react-error-boundary";
import reportWebVitals from "./reportWebVitals";
import { CrashScreen } from "./components/CrashScreen";

import * as Sentry from "@sentry/react";
import { projectSelector } from "@rflocal/shared";

if (!projectSelector.isLocal()) {
    Sentry.init({
        environment: projectSelector.env(),
        dsn: projectSelector.sentryDsn(),
        sendDefaultPii: false, // GDPR compliance

        // session recording;
        replaysSessionSampleRate: projectSelector.env() === "prod" ? 1 : 0.01, //100% in prod, 1% otherwise
        replaysOnErrorSampleRate: 1.0, // in case of error, 100% errors
        integrations: [
            Sentry.replayIntegration({
                maskAllText: false,
                maskAllInputs: false,
                blockAllMedia: true
            }),
            Sentry.replayCanvasIntegration()
        ]
    });
}

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
    <React.StrictMode>
        <ErrorBoundary
            FallbackComponent={CrashScreen}
            onError={(error, info) => {
                Sentry.captureException(error, {
                    contexts: { react: { componentStack: info.componentStack } }
                });
            }}
            onReset={(details) => {
                // best to just do a full reload, since state may be corrupted
                window.location.reload();
            }}
        >
            <App />
        </ErrorBoundary>
    </React.StrictMode>
);

reportWebVitals();
